"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.DrivingLicenceNumberValidation = void 0;
var journey_services_1 = require("@athena-portal/journey-services");
var drivingLicenceHelpers_1 = require("../helpers/drivingLicenceHelpers");
var enums_1 = require("../helpers/enums");
var DrivingLicenceNumberValidation = /** @class */ (function (_super) {
    __extends(DrivingLicenceNumberValidation, _super);
    function DrivingLicenceNumberValidation(props) {
        var _this = _super.call(this) || this;
        _this.props = props;
        if (!_this.props.interactionField) {
            throw Error("drivingLicenceNumberValidation missing interactionField attribute");
        }
        if (!_this.props.emptyFieldErrorMessage) {
            _this.props.emptyFieldErrorMessage = "Your driving licence number doesn’t look right! Enter your driving licence number.";
        }
        return _this;
    }
    DrivingLicenceNumberValidation.prototype.validateInput = function (input, context) {
        if (!input) {
            if (this.props.emptyFieldErrorMessage && context.interaction) {
                return this.invalidResult(journey_services_1.ExpressionEvaluator.renderTemplate(this.props.emptyFieldErrorMessage, context.interaction));
            }
            else {
                return this.invalidResult("Your driving licence number doesn’t look right! Enter your driving licence number.");
            }
        }
        if (context.interaction) {
            var person = journey_services_1.ObjectManipulator.fetchFieldValue(this.props.interactionField, context.interaction);
            var regex = /\s/;
            var trimmedLicence = input.replace(regex, '');
            var alphanumericRegex = /^[a-z0-9]+$/i;
            if (!alphanumericRegex.test(trimmedLicence) ||
                trimmedLicence.length < 16 ||
                trimmedLicence.length > 18 ||
                !drivingLicenceHelpers_1.default.validateLastNameSection(person.lastName, trimmedLicence.substring(0, 5).toUpperCase()) ||
                !drivingLicenceHelpers_1.default.validateBirthDateSection(person.dateOfBirth, trimmedLicence.substring(5, 11), context.interaction.product == enums_1.ProductsEnum.WOLF_MOTOR ? person.title : "none") ||
                !drivingLicenceHelpers_1.default.validateFirstNameSection(person.firstName, trimmedLicence.substring(11, 13).toUpperCase()) ||
                isNaN(trimmedLicence.substring(13, 14)) ||
                isNaN(trimmedLicence.substring(16))) {
                return this.invalidResult("Your driving licence number doesn’t look right! We validate driving licence number against your name, surname and date of birth, make sure these are entered correctly.");
            }
        }
        return this.validResult();
    };
    return DrivingLicenceNumberValidation;
}(journey_services_1.ValidationMethodBase));
exports.DrivingLicenceNumberValidation = DrivingLicenceNumberValidation;
//# sourceMappingURL=DrivingLicenceNumberValidation.js.map


//////////////////
// WEBPACK FOOTER
// ../falcon-services/dist/validations/DrivingLicenceNumberValidation.js
// module id = 2529
// module chunks = 0